/**
 * Socket.IO client transports (matches server `SocketIoAdapter` in API).
 * WebSocket first, then long-polling fallback.
 */
export const SOCKET_IO_TRANSPORTS = ["websocket", "polling"] as const;
